import { useEffect, useState } from "react";
import RadioGroup from "../../components/Form/RadioGroup";
import Search from "../../components/Form/Search";
import Button from "../../components/Form/Button";
import Modal from "../../components/Elements/Modal";
import ServicesItem from "../../components/Items/ServicesItem";
import AddServices from "../../components/Modals/AddServices";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  detailsService,
  listService,
  ordering,
} from "../../helpers/api_helper";
import { Loading } from "../../components/Elements/Loading";
import { Error } from "../../components/Elements/Error";
import { NoData } from "../../components/Elements/NoData";
import Pagination from "../../components/Elements/Pagination";
import { toast } from "react-toastify";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import Select from 'react-select';

const Banner = () => {
  // Query Client instance
  const queryClient = useQueryClient();

  // For Managing Modals
  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const [isOne, setDataOne] = useState(false);

  //Data
  const [dataList, setDataList] = useState([]);

  // For pagination
  const [perPages, setPerPages] = useState([
    { label: "10 (Default)", value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: "All", value: 999999 },
  ]);
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);

  // For Filtering Data 🔍
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState("");

  // To fetch Details of specific items when it needs to be edited
  const [editId, setEditId] = useState("");

  // Static status Radio buttons
  const [statusStatic, setStatusStatic] = useState([
    { _id: "", name: "All", color: "success", current: true },
    { _id: 1, name: "Published", color: "success", current: false },
    { _id: 2, name: "Coming Soon", color: "warning", current: false },
    { _id: 3, name: "Draft", color: "danger", current: false },
  ]);

  // Dynamic query key for Services 🗝️
  const queryServices = ["services", keyword, status, limit, offset];

  // For opening Add Modal althogh not mandetory
  const addModal = () => {
    setIsAddModal(true);
  };

  // For fetching details of item
  const {
    data: details,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["details", editId],
    queryFn: async () => detailsService({ id: editId }),
    enabled: false,
  });

  // Refetch when editId updates
  useEffect(() => {
    if (editId !== "") {
      refetch();
    }
  }, [editId, refetch]);

  // Services List Component
  function ServicesList() {
    // Custom hook for fetching Services list
    function useServices() {
      return useQuery({
        queryKey: queryServices,
        queryFn: () =>
          listService({
            keyword: keyword,
            sortByField: "ordering",
            sortByValue: 1,
            status: status,
            limit: limit,
            offset: offset,
          }),
        keepPreviousData: true,
      });
    }

    const { data: services, error, isFetching } = useServices();

    useEffect(() => {
      if (!isOne) {
        setDataList(services?.data);
      }
    }, [isOne, services?.data]);

    const handleDragEnd = (e) => {
      //console.log(e);
      if (!e.destination) return;
      let tempData = Array.from(dataList);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);
      // console.log(tempData);
      setDataList([...tempData]);
      let dataArray = [];
      for (let i = 0; i < tempData.length; i++) {
        dataArray.push({ id: tempData[i]._id, ordering: i + 1 });
      }
      // setOrderingData(dataArray);
      onClickSaveOrdering(dataArray);
      setDataOne(true);
    };
    const onClickSaveOrdering = async (orderingData) => {
      const saveOrdering = await ordering({
        orderingData: orderingData,
        tableName: "service",
      });

      if (saveOrdering.status === 200) {
        setDataOne(false);
        queryClient.invalidateQueries(queryServices);
        queryClient.removeQueries({
          queryKey: ["services"],
          type: "inactive",
        });
        toast.success(saveOrdering.message);
      } else {
        toast.error(saveOrdering.message);
      }
    };

    // Handling loading state 😑
    if (isFetching) {
      return <Loading />;
    }

    // Handling error state 🥴
    if (error) {
      return <Error />;
    }

    // Check if their is no data 🤨
    else if (services.data.length === 0) {
      return <NoData />;
    }

    // Renders the list
    else {
      return (
        // For Pagination
        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {dataList &&
                    dataList.length > 0 &&
                    dataList.map((item, index) => (
                      <ServicesItem
                        key={item._id}
                        index={index}
                        ServiceId={item._id}
                        image={item?.image}
                        name={item?.title}
                        descriptions={item?.description}
                        createdDate={moment(new Date(item?.created_at)).format(
                          "Do MMM YY"
                        )}
                        updatedDate={moment(new Date(item?.updated_at)).format(
                          "Do MMM YY"
                        )}
                        query={queryServices}
                        status={item?.status}
                        detailsFetch={refetch}
                        setEditId={setEditId}
                        setEditModal={setIsEditModal}
                      />
                    ))}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Pagination
            count={services.count}
            limit={limit}
            offset={offset}
            setOffset={setOffset}
          />
        </>
      );
    }
  }

  return (
    <>
      <div className="page-filter mb-3">
        <div className="input-filters d-flex justify-content-between">
          <div className="input-items">
            {perPages && (
              <div className="input">
                <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={perPages}
                  value={selectedPageOpt || []}
                  placeholder={"Per Page"}
                  onChange={(e) => {
                    setLimit(e.value);
                    setSelectedPageOpt(e);
                  }}
                />
              </div>
            )}
          </div>
          <div className="input-items">
            <Search
              state={keyword}
              setState={setKeyword}
              placeholder={"Search..."}
            />
          </div>

          <div className="input-items items-end gap-3 ms-auto ">
            <Button
              label={""}
              labelClasses={""}
              classes={"px-2"}
              icon={"fa-regular fa-arrow-rotate-right"}
              iconPosition={"left"}
              functions={() => {
                queryClient.invalidateQueries(queryServices);
                queryClient.removeQueries({
                  queryKey: ["services"],
                  type: "inactive",
                });
                setOffset(0);
                setKeyword("");
                setStatus("");
                setStatusStatic([]);
                setSelectedPageOpt([]);
                setTimeout(() => {
                  setStatusStatic([
                    { _id: "", name: "All", color: "success", current: true },
                    {
                      _id: 1,
                      name: "Published",
                      color: "success",
                      current: false,
                    },
                    {
                      _id: 2,
                      name: "Coming Soon",
                      color: "warning",
                      current: false,
                    },
                    {
                      _id: 3,
                      name: "Draft",
                      color: "danger",
                      current: false,
                    },
                  ]);
                }, 300);
              }}
            />
            <Button
              label={"Add"}
              labelClasses={""}
              classes={""}
              icon={"fa-regular fa-plus"}
              iconPosition={"left"}
              functions={addModal}
            />
          </div>
        </div>
        <div className="radio-filters">
          <RadioGroup
            data={statusStatic}
            setData={setStatus}
            inputName={"status"}
          />
        </div>
      </div>

      <div className="services-list">
        <ServicesList />
      </div>

      {/* // For add Modal */}
      <Modal
        title={"Add Services"}
        size={"md"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(false)}
      >
        <AddServices
          modalClose={() => setIsAddModal(false)}
          query={queryServices}
        />
      </Modal>

      {/* //For Edit Modal */}
      <Modal
        title={"Edit Services"}
        size={"md"}
        isOpen={isEditModal}
        modalClose={() => setIsEditModal(false)}
      >
        <AddServices
          modalClose={() => setIsEditModal(false)}
          query={queryServices}
          details={details}
          isFetching={isFetching}
        />
      </Modal>
    </>
  );
};

export default Banner;
